import embedIframeView from './embedIframeComponent.html';
import _ from 'lodash';
import { ensure } from '../../ensure/ensure.js';

export function embedIframeComponent() {
	return {
		bindings: {
			embed: '<',
		},
		controllerAs: 'vm',
		controller: embedIframeComponentCtrl,
		template: embedIframeView,
	};
}

export class embedIframeComponentCtrl {
	constructor($element) {
		'ngInject';
		this.$element = $element;
	}

	$postLink() {
		// grab dashboard element we may need for calculating height
		this.$embeds = angular.element(document.querySelector('.dashboard-embeds'));
		// initial resize after sh-bind-html is finished
		setTimeout(() => this.resize(), 33);
		// resize a second time in case partner links or other things load
		setTimeout(() => {
			this.resize();
			this.isSetUp = true;
		}, 1500);
	}

	$onChanges() {
		if (this.isSetUp) {
			// something such as this.embed changed after we set up
			this.resize();
		}
	}

	resize() {
		// we want to resize the iframe if it has a percent height and width
		const iframe = this.$element.find('iframe')[0];
		// read the actual iframe attributes instead of trying to extract attributes from this.embed
		const width = ensure.string(iframe.getAttribute('width') || '100%');
		const height = ensure.string(iframe.getAttribute('height') || '100%');
		// helper functions
		const isPercent = v => v.trim().slice(-1) === '%';
		const getNumber = v => v.trim().slice(0, -1);
		const getPreviousSiblings = node => {
			const siblings = [];
			if (node.parentNode) {
				let sibling = node.parentNode.firstChild;
				while (sibling && sibling !== node) {
					siblings.push(sibling);
					sibling = sibling.nextElementSibling;
				}
			}
			return siblings;
		};
		// for number: leave alone; for percent: use calc with vw
		if (isPercent(width)) {
			const vw = getNumber(width);
			// 30px padding on either side
			iframe.style.width = `calc(${vw}vw - 60px)`;
		} else {
			iframe.style.width = '';
		}
		// for number: leave alone; for percent: use calc with vh
		if (isPercent(height)) {
			const vh = getNumber(height);
			// we have to subtract the total height of the dashboard siblings
			let siblingHeight = 0;
			getPreviousSiblings(this.$embeds[0]).forEach(node => {
				if (node.getBoundingClientRect) {
					siblingHeight += node.getBoundingClientRect().height || 0;
				}
			});
			// add some bottom padding
			siblingHeight += 30;
			iframe.style.height = `calc(${vh}vh - ${siblingHeight}px)`;
		} else {
			iframe.style.height = '';
		}
	}
}
